/* src/app/forms/formula-tester/formula-tester.component.scss */
.direita {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-left: 10px;
  overflow: auto;
}
.warning-formula {
  color: red;
  font-size: 80%;
}
.cardcontent {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.action-image-buttons {
  font-size: 80%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.esquerda {
  width: 50%;
  margin-right: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  min-width: 250px;
}
.title-local {
  padding: 6px;
  text-align: center;
  font-size: 150%;
  font-weight: 500;
}
.fieldsize {
  height: 15%;
}
.fieldsize60 {
  height: 60%;
}
.bold {
  font-weight: bold;
}
mat-divider {
  margin-top: 10px;
}
.fieldsize25 {
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
}
.divcontent {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
}
.toolbar {
  height: 100%;
  font-size: 100%;
  flex: 1 1 auto;
}
.buttondiv {
  margin-top: 6px;
  float: right;
}
.span {
  flex: 1 1 auto;
  font-size: 70%;
  text-align: right;
  padding-right: 12px;
  display: inline-block;
  width: 100%;
  justify-content: center;
  padding-top: 20px;
}
.customtextarea {
  height: 100%;
  resize: none;
}
.customlist {
  justify-content: left !important;
  overflow-y: auto;
  border-style: inset;
  scroll-behavior: smooth;
  border-width: thin;
  align-items: normal !important;
  border-radius: 4px;
  height: 100%;
  max-height: 150px;
  min-height: 80px;
}
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.space {
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 6px;
}
formula-tester-action {
  height: 100%;
  display: flex;
  flex-direction: column;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  font-size: 90%;
}
.view-component-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  overflow: auto;
}
/*# sourceMappingURL=formula-tester.component.css.map */
